module.exports = __webpack_public_path__ + "static/media/logo.8e64db24.svg";